import { FC, PropsWithChildren, createContext, use, useMemo, useState } from 'react';
import { BaseColumnProvider } from '../types';

interface SimpleColumnProviderProps extends PropsWithChildren {
  initialColumns: string[];
}

const SimpleColumnContext = createContext<BaseColumnProvider | undefined>(undefined);

export const SimpleColumnProvider: FC<SimpleColumnProviderProps> = ({ children, initialColumns }) => {
  const [selectedColumns, setSelectedColumns] = useState<string[]>(initialColumns);

  const value = useMemo(
    () => ({
      selectedColumns,
      setSelectedColumns,
    }),
    [selectedColumns]
  );

  return <SimpleColumnContext value={value}>{children}</SimpleColumnContext>;
};

export const useSimpleColumnProvider = (): BaseColumnProvider => {
  const context = use(SimpleColumnContext);

  if (typeof context === 'undefined') {
    throw new Error('useSimpleColumnProvider cannot be used outside SimpleColumnProvider');
  }

  return context;
};
